// extracted by mini-css-extract-plugin
export default {"centered-view":"_1shk2d4","centeredView":"_1shk2d4","installed-icon":"_5ngeoi","installedIcon":"_5ngeoi","bundle-badge":"_1m6pabi","bundleBadge":"_1m6pabi"};